import './App.css';
import { useState } from 'react';
import MyButton from './components/button/MyButton';
import './Mainpage.css'

function MainPage() {

    const [text, setText] = useState('Выберите файл');
    const [size, setSize] = useState(0);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setText(file.name);
            setSize(file.size);
        } else {
            setText('Выберите файл');
        }
    };

  return (
    <div className='mainContainer'>
      <div>
        <div className='fileCard'>
            <div>
                <form method="post" enctype="multipart/form-data">
                    <label class="input-file">
                        <input type="file" name="file" onChange={handleFileChange} accept='.xlsx'/>
                        <span>{text}</span>
                    </label>
                </form>
            </div>
            <div>
                <div>
                    <p>Размер файла: {Math.round(size/1024 * 100) / 100} КБ</p>
                </div>
            <MyButton>
                <p>Получить отредактированное расписание</p>
            </MyButton>
            </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
